export const getCallIndividualApi = (
  cbpValue,
  activeDateValue,
  intMed,
  sapAthId,
  sunday,
  monday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  i1TmtOrgInvBilledYn,
  i2TmtOrgInvBilledYn,
  i3TmtOrgInvBilledYn,
  i4TmtOrgInvBilledYn,
  i5TmtOrgInvBilledYn,
  i6TmtOrgInvBilledYn,
  i7TmtOrgInvBilledYn,
  getCommonDropDownIndividual1,
  getCommonDropDownIndividual2,
  getCommonDropDownIndividual3,
  getCommonDropDownIndividual4,
  getCommonDropDownIndividual5,
  getCommonDropDownIndividual6,
  getCommonDropDownIndividual7,
  isStatusType,
  i1TmtTmtStsId,
  i2TmtTmtStsId,
  i3TmtTmtStsId,
  i4TmtTmtStsId,
  i5TmtTmtStsId,
  i6TmtTmtStsId,
  i7TmtTmtStsId,
  latestTmtStsId
) => {
  let intMedValue = '';
  if (latestTmtStsId === 2 && intMed === 3) {
    intMedValue = 3;
  }
  if (
    (latestTmtStsId === 18 || latestTmtStsId === 19 || latestTmtStsId === 6) &&
    intMed === 2
  ) {
    intMedValue = 1;
  } else if (
    (latestTmtStsId === 18 || latestTmtStsId === 19 || latestTmtStsId === 6) &&
    intMed === 3
  ) {
    intMedValue = 2;
  } else if (latestTmtStsId === 2 && intMed === 2) {
    intMedValue = intMed;
  } else {
    intMedValue = intMed;
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId === null &&
    i2TmtTmtStsId === null &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual1(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i1TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i2TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId !== null &&
    i2TmtTmtStsId === null &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i2TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    i1TmtTmtStsId === null &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual1(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i1TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId === null &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i2TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId == null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i1TmtTmtStsId' &&
    i2TmtTmtStsId !== null &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i2TmtTmtStsId' &&
    i3TmtTmtStsId === null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i3TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i2TmtTmtStsId' &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i2TmtTmtStsId' &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i2TmtTmtStsId' &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i2TmtTmtStsId' &&
    i3TmtTmtStsId !== null &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i3TmtTmtStsId' &&
    i4TmtTmtStsId === null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i4TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i3TmtTmtStsId' &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i3TmtTmtStsId' &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i3TmtTmtStsId' &&
    i4TmtTmtStsId !== null &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i4TmtTmtStsId' &&
    i5TmtTmtStsId === null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i5TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i4TmtTmtStsId' &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i4TmtTmtStsId' &&
    i5TmtTmtStsId !== null &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i5TmtTmtStsId' &&
    i6TmtTmtStsId === null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i6TmtOrgInvBilledYn
    );
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'i5TmtTmtStsId' &&
    i6TmtTmtStsId !== null &&
    i7TmtTmtStsId === null
  ) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'i6TmtTmtStsId' && i7TmtTmtStsId === null) {
    getCommonDropDownIndividual7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      i7TmtOrgInvBilledYn
    );
  }
};

export const getCallGroupApi = (
  cbpValue,
  activeDateValue,
  intMed,
  sapAthId,
  sunday,
  monday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  g1TmtOrgInvBilledYn,
  g2TmtOrgInvBilledYn,
  g3TmtOrgInvBilledYn,
  g4TmtOrgInvBilledYn,
  g5TmtOrgInvBilledYn,
  g6TmtOrgInvBilledYn,
  g7TmtOrgInvBilledYn,
  getCommonDropDownGroup1,
  getCommonDropDownGroup2,
  getCommonDropDownGroup3,
  getCommonDropDownGroup4,
  getCommonDropDownGroup5,
  getCommonDropDownGroup6,
  getCommonDropDownGroup7,
  isStatusType,
  g1TmtTmtStsId,
  g2TmtTmtStsId,
  g3TmtTmtStsId,
  g4TmtTmtStsId,
  g5TmtTmtStsId,
  g6TmtTmtStsId,
  g7TmtTmtStsId,
  latestTmtStsId
) => {
  let intMedValue = '';
  if (latestTmtStsId === 2 && intMed === 3) {
    intMedValue = 3;
  }
  if (
    (latestTmtStsId === 18 || latestTmtStsId === 19 || latestTmtStsId === 6) &&
    intMed === 2
  ) {
    intMedValue = 1;
  } else if (
    (latestTmtStsId === 18 || latestTmtStsId === 19 || latestTmtStsId === 6) &&
    intMed === 3
  ) {
    intMedValue = 2;
  } else if (latestTmtStsId === 2 && intMed === 2) {
    intMedValue = intMed;
  } else {
    intMedValue = intMed;
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId === null &&
    g2TmtTmtStsId === null &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup1(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g1TmtOrgInvBilledYn
    );
    getCommonDropDownGroup2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g2TmtOrgInvBilledYn
    );
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType === '' &&
    g1TmtTmtStsId !== null &&
    g2TmtTmtStsId === null &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g2TmtOrgInvBilledYn
    );
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId === null &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup2(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g2TmtOrgInvBilledYn
    );
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g1TmtTmtStsId' &&
    g2TmtTmtStsId !== null &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g2TmtTmtStsId' &&
    g3TmtTmtStsId === null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup3(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g3TmtOrgInvBilledYn
    );
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g2TmtTmtStsId' &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g2TmtTmtStsId' &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g2TmtTmtStsId' &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g2TmtTmtStsId' &&
    g3TmtTmtStsId !== null &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g3TmtTmtStsId' &&
    g4TmtTmtStsId === null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup4(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g4TmtOrgInvBilledYn
    );
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g3TmtTmtStsId' &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g3TmtTmtStsId' &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g3TmtTmtStsId' &&
    g4TmtTmtStsId !== null &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g4TmtTmtStsId' &&
    g5TmtTmtStsId === null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup5(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g5TmtOrgInvBilledYn
    );
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g4TmtTmtStsId' &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g4TmtTmtStsId' &&
    g5TmtTmtStsId !== null &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g5TmtTmtStsId' &&
    g6TmtTmtStsId === null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup6(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g6TmtOrgInvBilledYn
    );
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (
    isStatusType == 'g5TmtTmtStsId' &&
    g6TmtTmtStsId !== null &&
    g7TmtTmtStsId === null
  ) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'g6TmtTmtStsId' && g7TmtTmtStsId === null) {
    getCommonDropDownGroup7(
      cbpValue,
      activeDateValue,
      intMedValue,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      g7TmtOrgInvBilledYn
    );
  }
};

export const getCallDischargeApi = (
  cbpValue,
  activeDateValue,
  intMed,
  sapAthId,
  sunday,
  monday,
  MinTmtDateValue,
  SapAthAdmitDateValue,
  SapAthStartDateValue,
  SapAthEndDateValue,
  checkAdmValue,
  authToken,
  dispatch,
  d1TmtOrgInvBilledYn,
  d2TmtOrgInvBilledYn,
  d3TmtOrgInvBilledYn,
  d4TmtOrgInvBilledYn,
  d5TmtOrgInvBilledYn,
  d6TmtOrgInvBilledYn,
  d7TmtOrgInvBilledYn,
  getCommonDropDownDischarge1,
  getCommonDropDownDischarge2,
  getCommonDropDownDischarge3,
  getCommonDropDownDischarge4,
  getCommonDropDownDischarge5,
  getCommonDropDownDischarge6,
  getCommonDropDownDischarge7,
  isStatusType
) => {
  if (isStatusType === '') {
    getCommonDropDownDischarge1(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d1TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge2(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d2TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge3(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d3TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge4(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d4TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge5(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d5TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd1TmtTmtStsId') {
    getCommonDropDownDischarge2(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d2TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge3(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d3TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge4(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d4TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge5(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d5TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd2TmtTmtStsId') {
    getCommonDropDownDischarge3(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d3TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge4(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d4TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge5(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d5TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd3TmtTmtStsId') {
    getCommonDropDownDischarge4(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d4TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge5(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d5TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd4TmtTmtStsId') {
    getCommonDropDownDischarge5(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d5TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd5TmtTmtStsId') {
    getCommonDropDownDischarge6(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d6TmtOrgInvBilledYn
    );
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
  if (isStatusType == 'd6TmtTmtStsId') {
    getCommonDropDownDischarge7(
      cbpValue,
      activeDateValue,
      intMed,
      sapAthId,
      sunday,
      monday,
      MinTmtDateValue,
      SapAthAdmitDateValue,
      SapAthStartDateValue,
      SapAthEndDateValue,
      checkAdmValue,
      authToken,
      dispatch,
      d7TmtOrgInvBilledYn
    );
  }
};

export const generatePayloadForSave = (
  i1TmtTmtStsId,
  i2TmtTmtStsId,
  i3TmtTmtStsId,
  i4TmtTmtStsId,
  i5TmtTmtStsId,
  i6TmtTmtStsId,
  i7TmtTmtStsId,
  g1TmtTmtStsId,
  g2TmtTmtStsId,
  g3TmtTmtStsId,
  g4TmtTmtStsId,
  g5TmtTmtStsId,
  g6TmtTmtStsId,
  g7TmtTmtStsId,
  d1TmtTmtStsId,
  d2TmtTmtStsId,
  d3TmtTmtStsId,
  d4TmtTmtStsId,
  d5TmtTmtStsId,
  d6TmtTmtStsId,
  d7TmtTmtStsId,
  i1TmtFaceHours,
  i2TmtFaceHours,
  i3TmtFaceHours,
  i4TmtFaceHours,
  i5TmtFaceHours,
  i6TmtFaceHours,
  i7TmtFaceHours,
  i1TmtFaceMins,
  i2TmtFaceMins,
  i3TmtFaceMins,
  i4TmtFaceMins,
  i5TmtFaceMins,
  i6TmtFaceMins,
  i7TmtFaceMins,
  i1TmtSuppHours,
  i2TmtSuppHours,
  i3TmtSuppHours,
  i4TmtSuppHours,
  i5TmtSuppHours,
  i6TmtSuppHours,
  i7TmtSuppHours,
  i1TmtSuppMins,
  i2TmtSuppMins,
  i3TmtSuppMins,
  i4TmtSuppMins,
  i5TmtSuppMins,
  i6TmtSuppMins,
  i7TmtSuppMins,
  stop1Hours,
  stop2Hours,
  stop3Hours,
  stop4Hours,
  stop5Hours,
  stop6Hours,
  stop7Hours
) => {
  const payload = [];
  const saveIndividualTreat1 = {
    faceHoursPropertyName: 'I1TmtFaceHours',
    faceHours: i1TmtFaceHours ? +i1TmtFaceHours : null,
    suppHoursPropertyName: 'I1TmtSuppHours',
    suppHours: i1TmtSuppHours ? +i1TmtSuppHours : null,
    faceMinsPropertyName: 'I1TmtFaceMins',
    faceMins: i1TmtFaceMins ? +i1TmtFaceMins : null,
    suppMinsPropertyName: 'I1TmtSuppMins',
    suppMins: i1TmtSuppMins ? +i1TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I1TmtTmtStsID',
    tmtTmtStsId: i1TmtTmtStsId,
    stop1Hours: stop1Hours
  };
  const saveIndividualTreat2 = {
    faceHoursPropertyName: 'I2TmtFaceHours',
    faceHours: i2TmtFaceHours ? +i2TmtFaceHours : null,
    suppHoursPropertyName: 'I2TmtSuppHours',
    suppHours: i2TmtSuppHours ? +i2TmtSuppHours : null,
    faceMinsPropertyName: 'I2TmtFaceMins',
    faceMins: i2TmtFaceMins ? +i2TmtFaceMins : null,
    suppMinsPropertyName: 'I2TmtSuppMins',
    suppMins: i2TmtSuppMins ? +i2TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I2TmtTmtStsID',
    tmtTmtStsId: i2TmtTmtStsId,
    stop2Hours: stop2Hours
  };
  const saveIndividualTreat3 = {
    faceHoursPropertyName: 'I3TmtFaceHours',
    faceHours: i3TmtFaceHours ? +i3TmtFaceHours : null,
    suppHoursPropertyName: 'I3TmtSuppHours',
    suppHours: i3TmtSuppHours ? +i3TmtSuppHours : null,
    faceMinsPropertyName: 'I3TmtFaceMins',
    faceMins: i3TmtFaceMins ? +i3TmtFaceMins : null,
    suppMinsPropertyName: 'I3TmtSuppMins',
    suppMins: i3TmtSuppMins ? +i3TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I3TmtTmtStsID',
    tmtTmtStsId: i3TmtTmtStsId,
    stop3Hours: stop3Hours
  };
  const saveIndividualTreat4 = {
    faceHoursPropertyName: 'I4TmtFaceHours',
    faceHours: i4TmtFaceHours ? +i4TmtFaceHours : null,
    suppHoursPropertyName: 'I4TmtSuppHours',
    suppHours: i4TmtSuppHours ? +i4TmtSuppHours : null,
    faceMinsPropertyName: 'I4TmtFaceMins',
    faceMins: i4TmtFaceMins ? +i4TmtFaceMins : null,
    suppMinsPropertyName: 'I4TmtSuppMins',
    suppMins: i4TmtSuppMins ? +i4TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I4TmtTmtStsID',
    tmtTmtStsId: i4TmtTmtStsId,
    stop4Hours: stop4Hours
  };
  const saveIndividualTreat5 = {
    faceHoursPropertyName: 'I5TmtFaceHours',
    faceHours: i5TmtFaceHours ? +i5TmtFaceHours : null,
    suppHoursPropertyName: 'I5TmtSuppHours',
    suppHours: i5TmtSuppHours ? +i5TmtSuppHours : null,
    faceMinsPropertyName: 'I5TmtFaceMins',
    faceMins: i5TmtFaceMins ? +i5TmtFaceMins : null,
    suppMinsPropertyName: 'I5TmtSuppMins',
    suppMins: i5TmtSuppMins ? +i5TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I5TmtTmtStsID',
    tmtTmtStsId: i5TmtTmtStsId,
    stop5Hours: stop5Hours
  };
  const saveIndividualTreat6 = {
    faceHoursPropertyName: 'I6TmtFaceHours',
    faceHours: i6TmtFaceHours ? +i6TmtFaceHours : null,
    suppHoursPropertyName: 'I6TmtSuppHours',
    suppHours: i6TmtSuppHours ? +i6TmtSuppHours : null,
    faceMinsPropertyName: 'I6TmtFaceMins',
    faceMins: i6TmtFaceMins ? +i6TmtFaceMins : null,
    suppMinsPropertyName: 'I6TmtSuppMins',
    suppMins: i6TmtSuppMins ? +i6TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I6TmtTmtStsID',
    tmtTmtStsId: i6TmtTmtStsId,
    stop6Hours: stop6Hours
  };
  const saveIndividualTreat7 = {
    faceHoursPropertyName: 'I7TmtFaceHours',
    faceHours: i7TmtFaceHours ? +i7TmtFaceHours : null,
    suppHoursPropertyName: 'I7TmtSuppHours',
    suppHours: i7TmtSuppHours ? +i7TmtSuppHours : null,
    faceMinsPropertyName: 'I7TmtFaceMins',
    faceMins: i7TmtFaceMins ? +i7TmtFaceMins : null,
    suppMinsPropertyName: 'I7TmtSuppMins',
    suppMins: i7TmtSuppMins ? +i7TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'I7TmtTmtStsID',
    tmtTmtStsId: i7TmtTmtStsId,
    stop7Hours: stop7Hours
  };
  const saveGroupTreat1 = {
    faceHoursPropertyName: 'g1TmtFaceHours',
    faceHours: i1TmtFaceHours ? +i1TmtFaceHours : null,
    suppHoursPropertyName: 'g1TmtSuppHours',
    suppHours: i1TmtSuppHours ? +i1TmtSuppHours : null,
    faceMinsPropertyName: 'g1TmtFaceMins',
    faceMins: i1TmtFaceMins ? +i1TmtFaceMins : null,
    suppMinsPropertyName: 'g1TmtSuppMins',
    suppMins: i1TmtSuppMins ? +i1TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g1TmtTmtStsID',
    tmtTmtStsId: g1TmtTmtStsId,
  };
  const saveGroupTreat2 = {
    faceHoursPropertyName: 'g2TmtFaceHours',
    faceHours: i2TmtFaceHours ? +i2TmtFaceHours : null,
    suppHoursPropertyName: 'g2TmtSuppHours',
    suppHours: i2TmtSuppHours ? +i2TmtSuppHours : null,
    faceMinsPropertyName: 'g2TmtFaceMins',
    faceMins: i2TmtFaceMins ? +i2TmtFaceMins : null,
    suppMinsPropertyName: 'g2TmtSuppMins',
    suppMins: i2TmtSuppMins ? +i2TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g2TmtTmtStsID',
    tmtTmtStsId: g2TmtTmtStsId,
  };
  const saveGroupTreat3 = {
    faceHoursPropertyName: 'g3TmtFaceHours',
    faceHours: i3TmtFaceHours ? +i3TmtFaceHours : null,
    suppHoursPropertyName: 'g3TmtSuppHours',
    suppHours: i3TmtSuppHours ? +i3TmtSuppHours : null,
    faceMinsPropertyName: 'g3TmtFaceMins',
    faceMins: i3TmtFaceMins ? +i3TmtFaceMins : null,
    suppMinsPropertyName: 'g3TmtSuppMins',
    suppMins: i3TmtSuppMins ? +i3TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g3TmtTmtStsID',
    tmtTmtStsId: g3TmtTmtStsId,
  };
  const saveGroupTreat4 = {
    faceHoursPropertyName: 'g4TmtFaceHours',
    faceHours: i4TmtFaceHours ? +i4TmtFaceHours : null,
    suppHoursPropertyName: 'g4TmtSuppHours',
    suppHours: i4TmtSuppHours ? +i4TmtSuppHours : null,
    faceMinsPropertyName: 'g4TmtFaceMins',
    faceMins: i4TmtFaceMins ? +i4TmtFaceMins : null,
    suppMinsPropertyName: 'g4TmtSuppMins',
    suppMins: i4TmtSuppMins ? +i4TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g4TmtTmtStsID',
    tmtTmtStsId: g4TmtTmtStsId,
  };
  const saveGroupTreat5 = {
    faceHoursPropertyName: 'g5TmtFaceHours',
    faceHours: i5TmtFaceHours ? +i5TmtFaceHours : null,
    suppHoursPropertyName: 'g5TmtSuppHours',
    suppHours: i5TmtSuppHours ? +i5TmtSuppHours : null,
    faceMinsPropertyName: 'g5TmtFaceMins',
    faceMins: i5TmtFaceMins ? +i5TmtFaceMins : null,
    suppMinsPropertyName: 'g5TmtSuppMins',
    suppMins: i5TmtSuppMins ? +i5TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g5TmtTmtStsID',
    tmtTmtStsId: g5TmtTmtStsId,
  };
  const saveGroupTreat6 = {
    faceHoursPropertyName: 'g6TmtFaceHours',
    faceHours: i6TmtFaceHours ? +i6TmtFaceHours : null,
    suppHoursPropertyName: 'g6TmtSuppHours',
    suppHours: i6TmtSuppHours ? +i6TmtSuppHours : null,
    faceMinsPropertyName: 'g6TmtFaceMins',
    faceMins: i6TmtFaceMins ? +i6TmtFaceMins : null,
    suppMinsPropertyName: 'g6TmtSuppMins',
    suppMins: i6TmtSuppMins ? +i6TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g6TmtTmtStsID',
    tmtTmtStsId: g6TmtTmtStsId,
  };
  const saveGroupTreat7 = {
    faceHoursPropertyName: 'g7TmtFaceHours',
    faceHours: i7TmtFaceHours ? +i7TmtFaceHours : null,
    suppHoursPropertyName: 'g7TmtSuppHours',
    suppHours: i7TmtSuppHours ? +i7TmtSuppHours : null,
    faceMinsPropertyName: 'g7TmtFaceMins',
    faceMins: i7TmtFaceMins ? +i7TmtFaceMins : null,
    suppMinsPropertyName: 'g7TmtSuppMins',
    suppMins: i7TmtSuppMins ? +i7TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'g7TmtTmtStsID',
    tmtTmtStsId: g7TmtTmtStsId,
  };
  const saveDischargeTreat1 = {
    faceHoursPropertyName: 'd1TmtFaceHours',
    faceHours: i1TmtFaceHours ? +i1TmtFaceHours : null,
    suppHoursPropertyName: 'd1TmtSuppHours',
    suppHours: i1TmtSuppHours ? +i1TmtSuppHours : null,
    faceMinsPropertyName: 'd1TmtFaceMins',
    faceMins: i1TmtFaceMins ? +i1TmtFaceMins : null,
    suppMinsPropertyName: 'd1TmtSuppMins',
    suppMins: i1TmtSuppMins ? +i1TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd1TmtTmtStsID',
    tmtTmtStsId: d1TmtTmtStsId,
  };
  const saveDischargeTreat2 = {
    faceHoursPropertyName: 'd2TmtFaceHours',
    faceHours: i2TmtFaceHours ? +i2TmtFaceHours : null,
    suppHoursPropertyName: 'd2TmtSuppHours',
    suppHours: i2TmtSuppHours ? +i2TmtSuppHours : null,
    faceMinsPropertyName: 'd2TmtFaceMins',
    faceMins: i2TmtFaceMins ? +i2TmtFaceMins : null,
    suppMinsPropertyName: 'd2TmtSuppMins',
    suppMins: i2TmtSuppMins ? +i2TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd2TmtTmtStsID',
    tmtTmtStsId: d2TmtTmtStsId,
  };
  const saveDischargeTreat3 = {
    faceHoursPropertyName: 'd3TmtFaceHours',
    faceHours: i3TmtFaceHours ? +i3TmtFaceHours : null,
    suppHoursPropertyName: 'd3TmtSuppHours',
    suppHours: i3TmtSuppHours ? +i3TmtSuppHours : null,
    faceMinsPropertyName: 'd3TmtFaceMins',
    faceMins: i3TmtFaceMins ? +i3TmtFaceMins : null,
    suppMinsPropertyName: 'd3TmtSuppMins',
    suppMins: i3TmtSuppMins ? +i3TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd3TmtTmtStsID',
    tmtTmtStsId: d3TmtTmtStsId,
  };
  const saveDischargeTreat4 = {
    faceHoursPropertyName: 'd4TmtFaceHours',
    faceHours: i4TmtFaceHours ? +i4TmtFaceHours : null,
    suppHoursPropertyName: 'd4TmtSuppHours',
    suppHours: i4TmtSuppHours ? +i4TmtSuppHours : null,
    faceMinsPropertyName: 'd4TmtFaceMins',
    faceMins: i4TmtFaceMins ? +i4TmtFaceMins : null,
    suppMinsPropertyName: 'd4TmtSuppMins',
    suppMins: i4TmtSuppMins ? +i4TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd4TmtTmtStsID',
    tmtTmtStsId: d4TmtTmtStsId,
  };
  const saveDischargeTreat5 = {
    faceHoursPropertyName: 'd5TmtFaceHours',
    faceHours: i5TmtFaceHours ? +i5TmtFaceHours : null,
    suppHoursPropertyName: 'd5TmtSuppHours',
    suppHours: i5TmtSuppHours ? +i5TmtSuppHours : null,
    faceMinsPropertyName: 'd5TmtFaceMins',
    faceMins: i5TmtFaceMins ? +i5TmtFaceMins : null,
    suppMinsPropertyName: 'd5TmtSuppMins',
    suppMins: i5TmtSuppMins ? +i5TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd5TmtTmtStsID',
    tmtTmtStsId: d5TmtTmtStsId,
  };
  const saveDischargeTreat6 = {
    faceHoursPropertyName: 'd6TmtFaceHours',
    faceHours: i6TmtFaceHours ? +i6TmtFaceHours : null,
    suppHoursPropertyName: 'd6TmtSuppHours',
    suppHours: i6TmtSuppHours ? +i6TmtSuppHours : null,
    faceMinsPropertyName: 'd6TmtFaceMins',
    faceMins: i6TmtFaceMins ? +i6TmtFaceMins : null,
    suppMinsPropertyName: 'd6TmtSuppMins',
    suppMins: i6TmtSuppMins ? +i6TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd6TmtTmtStsID',
    tmtTmtStsId: d6TmtTmtStsId,
  };
  const saveDischargeTreat7 = {
    faceHoursPropertyName: 'd7TmtFaceHours',
    faceHours: i7TmtFaceHours ? +i7TmtFaceHours : null,
    suppHoursPropertyName: 'd7TmtSuppHours',
    suppHours: i7TmtSuppHours ? +i7TmtSuppHours : null,
    faceMinsPropertyName: 'd7TmtFaceMins',
    faceMins: i7TmtFaceMins ? +i7TmtFaceMins : null,
    suppMinsPropertyName: 'd7TmtSuppMins',
    suppMins: i7TmtSuppMins ? +i7TmtSuppMins : null,
    tmtTmtStsIdPropertyName: 'd7TmtTmtStsID',
    tmtTmtStsId: d7TmtTmtStsId,
  };
  
//allow deletes
  //if (i1TmtTmtStsId) {
    payload.push(saveIndividualTreat1);
  //}
  //if (i2TmtTmtStsId) {
    payload.push(saveIndividualTreat2);
  //}
  //if (i3TmtTmtStsId) {
    payload.push(saveIndividualTreat3);
  //}
  //if (i4TmtTmtStsId) {
    payload.push(saveIndividualTreat4);
  //}
  //if (i5TmtTmtStsId) {
    payload.push(saveIndividualTreat5);
  //}
  //if (i6TmtTmtStsId) {
    payload.push(saveIndividualTreat6);
  //}
  //if (i7TmtTmtStsId) {
    payload.push(saveIndividualTreat7);
  //}
  //if (g1TmtTmtStsId) {
    payload.push(saveGroupTreat1);
  //}
  //if (g2TmtTmtStsId) {
    payload.push(saveGroupTreat2);
  //}
  //if (g3TmtTmtStsId) {
    payload.push(saveGroupTreat3);
  //}
  //if (g4TmtTmtStsId) {
    payload.push(saveGroupTreat4);
  //}
  //if (g5TmtTmtStsId) {
    payload.push(saveGroupTreat5);
  //}
  //if (g6TmtTmtStsId) {
    payload.push(saveGroupTreat6);
  //}
  //if (g7TmtTmtStsId) {
    payload.push(saveGroupTreat7);
  //}
  //if (d1TmtTmtStsId) {
    payload.push(saveDischargeTreat1);
  //}
  //if (d2TmtTmtStsId) {
    payload.push(saveDischargeTreat2);
  //}
  //if (d3TmtTmtStsId) {
    payload.push(saveDischargeTreat3);
  //}
  //if (d4TmtTmtStsId) {
    payload.push(saveDischargeTreat4);
  //}
  //if (d5TmtTmtStsId) {
    payload.push(saveDischargeTreat5);
  //}
  //if (d6TmtTmtStsId) {
    payload.push(saveDischargeTreat6);
  //}
  //if (d7TmtTmtStsId) {
    payload.push(saveDischargeTreat7);
  //}
  return payload;
};
